import { Field, Dropdown, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { createYesNoOptions } from '@/config/formOptions';

// Scope of certification of raw material — RED III Art. 29(2)-(7), shared by every declaration flow.

const yesNoOptions = createYesNoOptions({ yes: true, no: false });

/**
 * Props: (none)
 */
export const SustainabilityCriteriaComplianceField = () => {
  const t = useTranslations();

  return (
    <Field name="sustainabilityCriteriaCompliance" required>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FIELD_SUSTAINABILITY_CRITERIA_COMPLIANCE')}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const IntermediateCropField = () => {
  const t = useTranslations();

  return (
    <Field name="intermediateCrop">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <Dropdown
          searchable
          id={id}
          name={name}
          label={t('FORM_INTERMEDIATE_CROP')}
          placeholder={t('COMMON_SELECT')}
          noResultsMessage={t('COMMON_NO_MATCHES')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const LowIlucRiskFeedstockField = () => {
  const t = useTranslations();

  return (
    <Field name="lowIlucRiskFeedstock">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <Dropdown
          searchable
          id={id}
          name={name}
          label={t('FORM_LOW_ILUC_RISK_FEEDSTOCK')}
          placeholder={t('COMMON_SELECT')}
          noResultsMessage={t('COMMON_NO_MATCHES')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const WasteOrResidueDefinitionField = () => {
  const t = useTranslations();

  return (
    <Field name="wasteOrResidueDefinition" required>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FIELD_WASTE_OR_RESIDUE_DEFINITION')}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const WasteOrByProductPermitNumberField = () => {
  const t = useTranslations();

  return (
    <Field name="wasteOrByProductPermitNumber">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_WASTE_OR_BY_PRODUCT_PERMIT_NUMBER')}
          placeholder={t('FORM_PERMIT_NUMBER_PLACEHOLDER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const ProductionSupportReceivedField = () => {
  const t = useTranslations();

  return (
    <Field name="productionSupportReceived" required>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FIELD_PRODUCTION_SUPPORT_RECEIVED')}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};

/**
 * Props: (none)
 */
export const SupportNatureAndSchemeField = () => {
  const t = useTranslations();

  return (
    <Field name="supportNatureAndScheme">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_SUPPORT_NATURE_AND_SCHEME')}
          placeholder={t('FORM_PERMIT_NUMBER_PLACEHOLDER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
        />
      )}
    </Field>
  );
};
